var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSlotsicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_13_11",
    "data-name": "Component 13 \\u2013 11",
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 50.011,
    viewBox: "0 0 56 50.011",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_392",
    "data-name": "Path 392",
    d: "M1163.81,269.433A14.944,14.944,0,0,0,1149.22,271a19.418,19.418,0,0,1-.006,24.6,15.063,15.063,0,1,0,14.6-26.17Zm1.6,15.488h-.037a2.151,2.151,0,0,1-2.145-2.117,4.867,4.867,0,0,0-3.532-4.627,2.154,2.154,0,0,1,1.178-4.143,9.149,9.149,0,0,1,6.645,8.7A2.15,2.15,0,0,1,1165.408,284.921Zm-25.193-15.488a15.073,15.073,0,1,0,7.887,19.8A15,15,0,0,0,1140.215,269.433Zm1.6,15.488h-.037a2.151,2.151,0,0,1-2.145-2.118,4.928,4.928,0,0,0-3.532-4.626,2.154,2.154,0,0,1,1.179-4.143,9.149,9.149,0,0,1,6.645,8.7A2.151,2.151,0,0,1,1141.812,284.921Zm-2.211-22.706,6.134-6.637,6.137,6.637a2.139,2.139,0,0,0,3.032.113,2.16,2.16,0,0,0,.112-3.045l-7.709-8.338a2.206,2.206,0,0,0-3.145,0l-7.707,8.338a2.15,2.15,0,1,0,3.146,2.932Zm29.294-7.439a21.752,21.752,0,0,0-18.176-6.237l24.384,24.486A21.946,21.946,0,0,0,1168.9,254.777Z",
    transform: "translate(-1119.273 -248.37)",
    fill: "#e660a7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlotsicon);
export default __webpack_public_path__ + "lbHeaderFiles/static/media/slots.icon.bc0eda9ab020fc34fddcadc5651f70b0.svg";
export { ForwardRef as ReactComponent };